var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgFastForwardCircle(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M17.25 6.078c4.332.543 7.603 3.765 8.498 7.687a.625.625 0 11-1.218.278c-1.532-6.708-9.867-9.08-14.715-4.23-3.412 3.411-3.412 8.962 0 12.373 3.36 3.36 8.91 3.463 12.372 0a8.722 8.722 0 002.349-4.257.625.625 0 011.22.274c-1.71 7.602-11.228 10.465-16.825 4.867a9.994 9.994 0 010-14.141 9.982 9.982 0 018.32-2.85zm-.182 6.667l2.812 2.813a.625.625 0 010 .883l-2.812 2.813a.626.626 0 01-.884-.884l2.37-2.37-2.37-2.371a.625.625 0 01.884-.884zm-3.437 0l2.812 2.813a.625.625 0 010 .883l-2.812 2.813a.626.626 0 01-.884-.884l2.37-2.37-2.37-2.371a.625.625 0 01.884-.884zm11.737 2.59a.625.625 0 01.632.618v.093a.625.625 0 11-1.25-.013v-.067a.625.625 0 01.618-.631z"
  }));
}

export default SvgFastForwardCircle;